<ngx-spinner type="ball-clip-rotate"></ngx-spinner>

<div class="container">
  <div class="inner" style="display: flex; flex-direction: column; text-align: center;">
    <h1 class="h3 mb-6">認証メールの再送信</h1>

    <div class="mb-6">
      <p class="text-body-1">
        下記に登録したメールアドレスを入力してください。再度、認証メールをお送りします。
      </p>
  
    </div>
    <form
      id="change-password-form"
      class="v-application--is-ltr"
      (submit)="submit()"
    >
      <div
        class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
      >
        <div class="v-input__control mb-6">
          <app-collabo-portal-input
            [(ngModel)]="email"
            name="email"
            placeholder="メールアドレス"
            class="text-black-38"
          ></app-collabo-portal-input>
        </div>
      </div>

      <div _ngcontent-ohw-c49="" class="text-center mb-5">
        <button
          _ngcontent-ohw-c49=""
          type="submit"
          medium=""
          class="full-width primary-button v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
        >
          <span _ngcontent-ohw-c49="" class="text-button-medium v-btn__content">
            送信する
          </span>
        </button>
      </div>
    </form>
  </div>
</div>
